import { FileStatus } from 'services/file.service';

export const sortProjectEntities = <T>(
  entities: T[],
  order: 'ASC' | 'DESC',
  cb: (data: T) => string | number | Date
) => {
  const isAscending = order === 'ASC';
  return entities.sort((a, b) => {
    const A = cb(a);
    const B = cb(b);
    if (typeof A === 'string') return isAscending ? A.localeCompare(B as string) : (B as string).localeCompare(A);
    if (A > B) return isAscending ? 1 : -1;
    if (A < B) return isAscending ? -1 : 1;
    return 0;
  });
};

const FILE_STATUS_LABELS: Partial<Record<FileStatus, string>> = {
  [FileStatus.PendingUpload]: 'Pending upload',
  [FileStatus.UploadingToAWS]: 'Uploading to AWS',
  [FileStatus.PendingProcessing]: 'Pending processing',
  [FileStatus.UploadingToProcessingServer]: 'Uploading to processing server',
  [FileStatus.PendingProcessingEffects]: 'Pending processing effects',
  [FileStatus.PendingChangingMediaOriginDate]: 'Pending Changing Media Origin Date',
  [FileStatus.PendingDownloadingFromGoogle]: 'Pending Downloading From Google',
};

export const mapFileStatusToLabel = (status: FileStatus): string => FILE_STATUS_LABELS[status] ?? FileStatus[status];
